// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4ee7ad786401a5a27ba4","655":"d946999f6977a374195d"}[chunkId] + ".js";
};